import React from 'react';
import BlogPost from './BlogPost/BlogPost';
import BlogPost1 from '../../../../assets/Blog_Post_1.jpg';
import BlogPost2 from '../../../../assets/Blog_Post_2.jpg';
import BlogPost3 from '../../../../assets/Blog_Post_3.jpg';

import './BlogSection.css';

const BlogSection = () => {
    const blogPosts = [
        {
            title: "Crypto...A New Currency",
            description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Saepe, architecto. Harum corporis reprehenderit deserunt quis, deleniti quidem. Vitae, corrupti? Similique inventore perferendis eaque quia laboriosam aliquam animi maiores quasi voluptatibus.",
            image: BlogPost1
        },
        {
            title: "Money Market is Falling Down",
            description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Saepe, architecto. Harum corporis reprehenderit deserunt quis, deleniti quidem. Vitae, corrupti? Similique inventore perferendis eaque quia laboriosam aliquam animi maiores quasi voluptatibus.",
            image: BlogPost2
        },
        {
            title: "Power of Investing",
            description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Saepe, architecto. Harum corporis reprehenderit deserunt quis, deleniti quidem. Vitae, corrupti? Similique inventore perferendis eaque quia laboriosam aliquam animi maiores quasi voluptatibus.",
            image: BlogPost3
        },
    ]
    return (
        <div className="container blog__section_container mx-auto">
            <h5 className="blog__section__mainHeading">
               Latest Newsfeed
            </h5>
            <h2 className="blog__section__subHeading">
                Our recent blog post that updated
            </h2>
            <div className="row blog__section__subSection justify-content-between">
                {
                    blogPosts.map((blog, i) => (
                        <div className="col-md-6 col-lg-4" key={i}>
                            <BlogPost blog={blog} />
                        </div>
                    ))
                }
            </div>
  </div>
    )
}

export default BlogSection
